export const universityNames = [
  'Abertay University',
  'Aberystwyth University',
  'Acadia University',
  'Algoma University',
  'Ambrose University',
  'Anglia Ruskin University',
  'Arts University Bournemouth',
  'Aston University',
  'Aurora College',
  'Bangor University',
  'Bath Spa University',
  'Birkbeck, University of London',
  'Birmingham City University',
  'University of Birmingham',
  'Bishop Grosseteste University',
  "Bishop's University",
  'Bournemouth University',
  'BPP University',
  'Brandon University',
  'British Columbia Institute of Technology',
  'Brock University',
  'Brunel University London',
  'Buckinghamshire New University',
  'Burman University',
  'Campion College at the University of Regina',
  'Canadian Mennonite University',
  'Canterbury Christ Church University',
  'Cape Breton University',
  'Capilano University',
  'Cardiff Metropolitan University',
  'Cardiff University',
  'Carleton University',
  'CCLASP',
  'City, University of London',
  'College of the North Atlantic',
  'Collège Universitaire Dominicain',
  'Concordia University of Edmonton',
  'Concordia University',
  'Cornell University',
  'Coventry University',
  'Crandall University',
  'Cranfield University',
  'Dalhousie University',
  'De Montfort University',
  'Durham University',
  'École de Technologie Supérieure',
  "École Nationale d'Administration Publique",
  'École Polytechnique de Montréal',
  'Edge Hill University',
  'Edinburgh Napier University',
  'Emily Carr University of Art and Design',
  'European School of Economics',
  'Falmouth University',
  'First Nations University of Canada',
  'Glasgow Caledonian University',
  'Glasgow Clyde College',
  'Scottish Enterprise',
  'Goldsmiths, University of London',
  'Guildhall School of Music and Drama',
  'Harper Adams University',
  'Hartpury University and Hartpury College',
  'HEC Montréal',
  'Heriot-Watt University',
  'Imperial College London',
  'Keele University',
  "King's College London",
  'Kingston University',
  'Kingswood University',
  'Kwantlen Polytechnic University',
  'Lakehead University',
  'Lancaster University',
  'Laurentian University',
  'Leeds Arts University',
  'Leeds Beckett University',
  'Leeds Conservatoire',
  'Leeds Trinity University',
  'Liverpool Hope University',
  'Liverpool Institute for Performing Arts',
  'Liverpool John Moores University',
  'Liverpool School of Tropical Medicine',
  'London Business School',
  'London Metropolitan University',
  'London School of Hygiene and Tropical Medicine, University of London',
  'London South Bank University',
  'Loughborough University',
  'Luther College at the University of Regina',
  'MacEwan University',
  'Manchester Metropolitan University',
  'McGill University',
  'McMaster University',
  'Memorial University of Newfoundland',
  'Middlesex University',
  'Mount Allison University',
  'Mount Royal University',
  'Mount Saint Vincent University',
  'Net Natives',
  'Newcastle University',
  'Newman University, Birmingham',
  'Nicola Valley Institute of Technology',
  'Nipissing University',
  'Northern Alberta Institute of Technology',
  'Northern School of Contemporary Dance',
  'Northumbria University',
  'Norwich University of the Arts',
  'Nottingham Trent University',
  'NSCAD University',
  'OCAD University',
  'Ontario Tech University',
  'Oxford Brookes University',
  'Plymouth College of Art',
  'Plymouth Marjon University',
  'PSEWeb',
  'Queen Margaret University',
  'Queen Mary University of London',
  "Queen's University Belfast",
  "Queen's University",
  'Quest University Canada',
  'Ravensbourne University London',
  'Redeemer University College',
  "Regent's University London",
  'Richmond, The American International University in London',
  'Robert Gordon University',
  'Rose Bruford College',
  'Royal Academy of Music, University of London',
  'Royal Agricultural University',
  'Royal College of Art',
  'Royal College of Music',
  'Royal Conservatoire of Scotland',
  'Royal Holloway, University of London',
  'Royal Military College of Canada',
  'Royal Northern College of Music',
  'Royal Roads University',
  'Royal Veterinary College University of London',
  "Saint Mary's University",
  'School of Advanced Study, University of London',
  "Scotland's Rural College",
  'Sheffield Hallam University',
  'Simon Fraser University',
  'SOAS, University of London',
  'Solent University',
  'Southern Alberta Institute of Technology',
  "St George's, University of London",
  "St Mary's University, Twickenham",
  "St Mary's University",
  'St. Francis Xavier University',
  "St. Stephen's University",
  'St. Thomas More College',
  'St. Thomas University',
  'Staffordshire University',
  'Swansea University',
  'Teesside University',
  'The Courtauld Institute of Art, University of London',
  'The Glasgow School of Art',
  'The High School of Glasgow',
  'The King’s University',
  'The London Institute of Banking and Finance',
  'The London School of Economics and Political Science',
  'The Royal Central School of Speech and Drama',
  'The Oratory Prep School',
  'The University of British Columbia',
  'The University of Buckingham',
  'The University of Edinburgh',
  'The University of Hull',
  'The University of Law',
  'The University of Manchester',
  'The University of Northampton',
  'The University of Nottingham',
  'The University of Sheffield',
  'The University of Warwick',
  'The University of Winchester',
  'The University of Winnipeg',
  'The University of York',
  'Thompson Rivers University',
  'Toronto Metropolitan University',
  'Trent University',
  'Trinity Laban Conservatoire of Music and Dance',
  'Trinity Western University',
  'Ulster University',
  'Université de Hearst',
  'Université de Moncton',
  'Université de Montréal',
  'Université de Saint-Boniface',
  'Université de Sherbrooke',
  'Université du Québec à Chicoutimi',
  'Université du Québec à Montréal',
  'Université du Québec à Rimouski',
  'Université du Québec à Trois-Rivières',
  'Université du Québec en Abitibi-Témiscamingue',
  'Université du Québec en Outaouais',
  'Université du Québec',
  'Université Laval',
  'Université Sainte-Anne',
  'University Canada West',
  'University College Birmingham',
  'University College London',
  'University for the Creative Arts',
  'University of Aberdeen',
  'University of Alberta',
  'University of Bath',
  'University of Bedfordshire',
  'University of Birmingham',
  'University of Bolton',
  'University of Bradford',
  'University of Brighton',
  'University of Bristol',
  'University of Calgary',
  'University of Cambridge',
  'University of Central Lancashire',
  'University of Chester',
  'University of Chichester',
  'University of Cumbria',
  'University of Derby',
  'University of Dundee',
  'University of East Anglia',
  'University of East London',
  'University of Essex',
  'University of Exeter',
  'University of Glasgow',
  'University of Gloucestershire',
  'University of Greenwich',
  'University of Guelph',
  'University of Hertfordshire',
  'University of Huddersfield',
  'University of Kent',
  "University of King's College",
  'University of Leeds',
  'University of Leicester',
  'University of Lethbridge',
  'University of Lincoln',
  'University of Liverpool',
  'University of London',
  'University of Manitoba',
  'University of New Brunswick',
  'University of Northern British Columbia',
  'University of Ottawa',
  'University of Oxford',
  'University of Plymouth',
  'University of Portsmouth',
  'University of Prince Edward Island',
  'University of Reading',
  'University of Regina',
  'University of Roehampton',
  'University of Salford',
  'University of Saskatchewan',
  'University of South Wales',
  'University of Southampton',
  'University of St Andrews',
  'University of Stirling',
  'University of Strathclyde',
  'University of Suffolk',
  'University of Sunderland',
  'University of Surrey',
  'University of Sussex',
  'University of Sussex US',
  'University of the Arts London',
  'University of the Fraser Valley',
  'University of the Highlands and Islands',
  'University of the West of England',
  'University of the West of Scotland',
  'University of Toronto',
  'University of Victoria',
  'University of Wales Trinity Saint David',
  'University of Wales',
  'University of Waterloo',
  'University of West London',
  'University of Westminster',
  'University of Windsor',
  'University of Wolverhampton',
  'University of Worcester',
  'Vancouver Island University',
  'Western University',
  'Wilfrid Laurier University',
  'Wrexham Glyndwr University',
  'Writtle University College',
  'York St John University',
  'York University',
  'Yorkville University',
  '448 Studio',
  'Forumm',
  'FindAUniversity',
  'Lancaster University',
  'Launch Foods Foundation',
  'Pickle Jar Communications',
  'Trials and Errors',
  'Eagle Labs',
  'Barclays',
  'Adam Smith Business School',
  'Catholic Foundation',
  'University of Glasgow Sport',
  'Cairney & Company',
]
